import React from 'react';
import styles from './sidebar.module.css';

const SideBar = ({children}) => {
  return <div className={styles.navFrame}>
   {children}
   </div>;
}

export default SideBar;



// WEBPACK FOOTER //
// ./src/components/SideBar/index.js